import React, { useCallback } from 'react';
import {
  Form as FinalForm,
  AnyObject,
  FormRenderProps,
  FormSpy,
} from 'react-final-form';
import styled from 'styled-components';
import { useToaster } from '../../hooks';
import { Content } from '../Content';
import { FormProps } from './Form.types';

const StyledForm = styled.form`
  button {
    margin: 1rem 0;
  }

  > * {
    margin-bottom: 1rem;
  }

  @media (max-width: 1000px) {
    > * {
      margin-bottom: 0px;
    }
  }
`;

export function Form<FormValues = AnyObject>(props: FormProps<FormValues>) {
  const { children, id, 'data-testid': dataTestId, ...restOfProps } = props;
  const { toast, toaster } = useToaster();

  const renderChildren = useCallback(
    (formProps: FormRenderProps<FormValues>) => {
      return typeof children === 'function' ? children(formProps) : children;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [children],
  );

  return (
    <Content>
      <FinalForm {...restOfProps}>
        {formProps => {
          return (
            <StyledForm
              id={id}
              data-testid={dataTestId}
              onSubmit={formProps.handleSubmit}
            >
              <FormSpy
                subscription={{ submitFailed: true }}
                onChange={formSpyProps => {
                  if (formSpyProps.submitFailed) {
                    toaster(
                      toast.error(
                        'Please correct the form errors.',
                        'Submit failed',
                      ),
                    );
                  }
                }}
              />
              {renderChildren(formProps)}
            </StyledForm>
          );
        }}
      </FinalForm>
    </Content>
  );
}
